import React, {Component} from 'react';
import {connect} from 'react-redux';
import {findCategoryInList} from 'base/lib/findCategoryInList';
import {ItemCategory} from 'components/partials/item-category';
import _CategoryContent from './_CategoryContainer.scss';
import {setDataBreadCrumb} from 'actions';
import {NoContent} from 'components/no-content';
import {ShowIf} from 'components/utils';
import {Categories} from 'api';

class CategoriesContainer extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      subCategories: [],
      category: [],
      hasBreadcrumb: true
    };
  }

  componentDidMount() {
    if (this.props.id && this.props.categories.length > 0) {
      let matchedCategory = findCategoryInList(this.props.id, this.props.categories);
      this.setState({
        category: matchedCategory || []
      });
      this.handleBreadcrumb(matchedCategory ? matchedCategory.name : '');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.id && nextProps.categories.length > 0) {
      let matchedCategory = findCategoryInList(nextProps.id, nextProps.categories);
      this.setState({
        category: matchedCategory || []
      });
      this.handleBreadcrumb(matchedCategory ? matchedCategory.name : '');
    }
  }

  handleBreadcrumb(categoryName) {
    let breadcrumb = [
      {name: 'Trang chủ', link: '/'},
      {name: 'Sản phẩm', link: '/all-categories'}
    ];
    if (categoryName && categoryName !== '') {
      breadcrumb.push({name: categoryName});
    }
    this.props.dispatch(setDataBreadCrumb(this.state.hasBreadcrumb, breadcrumb));
  }

  render() {
    let data = this.state.category && this.state.category.children ? this.state.category.children : [];
    return (
      <section className="right-content">
        <ShowIf condition={data.length > 0}>
          <div>
            {
              this.state.category && this.state.category.children && this.state.category.children.map((category, id) => {
                return (
                  <ItemCategory for="product" key={id} category={category}/>
                );
              })
            }
          </div>
        </ShowIf>
        <ShowIf condition={data.length == 0}>
          <NoContent content='Không có thiết bị nào' height={600}/>
        </ShowIf>
      </section>
    );
  }

}

let bindStateToProps = (state) => {
  return {
    categories: state.categoriesAsTree
  };
};

export default connect(bindStateToProps)(CategoriesContainer);



// WEBPACK FOOTER //
// ./components/category/CategoriesContainer.jsx